/* vb-gaveta — o que a gaveta precisa de comportamento: o contador do anúncio,
 * a barra de recompensa e os upsells.
 *
 * Falha aberto: qualquer erro aqui deixa a gaveta do tema como ela era.
 * O contador vive no armazenamento local, então ele não reinicia a cada página.
 */
(function () {
  'use strict';
  if (window.VbGaveta) return;
  window.VbGaveta = true;

  var CHAVE = 'vb-gaveta-fim';

  function dois(n) { return (n < 10 ? '0' : '') + n; }

  /* ------------------------------------------------------------- contador */
  function fimDoPrazo(segundos) {
    var fim = parseInt(localStorage.getItem(CHAVE) || '0', 10);
    var agora = Date.now();
    if (!fim || fim <= agora) {
      fim = agora + segundos * 1000;
      try { localStorage.setItem(CHAVE, String(fim)); } catch (e) { /* sessão privada */ }
    }
    return fim;
  }
  function ligarContador() {
    var caixa = document.querySelector('[data-vb-timer]');
    if (!caixa) return;
    var alvo = caixa.querySelector('[data-vb-relogio]');
    if (!alvo) return;
    var segundos = parseInt(caixa.getAttribute('data-vb-timer'), 10) || 600;
    var fim = fimDoPrazo(segundos);
    function passo() {
      var vivo = document.querySelector('[data-vb-relogio]');
      if (!vivo) return;
      var resta = Math.max(0, Math.round((fim - Date.now()) / 1000));
      var texto = dois(Math.floor(resta / 60)) + ':' + dois(resta % 60);
      if (vivo.textContent !== texto) vivo.textContent = texto;
      if (resta <= 0) { fim = fimDoPrazo(segundos); }
    }
    passo();
    if (window.__vbRelogio) clearInterval(window.__vbRelogio);
    window.__vbRelogio = setInterval(passo, 1000);
  }

  /* ------------------------------------------------- adicionar um upsell */
  function raiz() {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  }
  function abrirGaveta() {
    var g = document.querySelector('cart-drawer');
    if (!g) return;
    if (typeof g.open === 'function') g.open();
    else g.classList.add('active', 'animate');
  }
  function recarregarGaveta(abrir) {
    // pede ao tema as seções da gaveta; é assim que o Dawn se atualiza sozinho
    fetch(raiz() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var alvo = document.querySelector('cart-drawer');
        if (alvo && s['cart-drawer']) {
          var novo = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
          if (novo) {
            var aberta = alvo.classList.contains('active') || alvo.classList.contains('animate');
            alvo.innerHTML = novo.innerHTML;
            alvo.classList.toggle('is-empty', novo.classList.contains('is-empty'));
            if (aberta) { alvo.classList.add('active', 'animate'); }
            if (abrir) { abrirGaveta(); }
            var tapa = alvo.querySelector('#CartDrawer-Overlay');
            if (tapa && alvo.close) tapa.addEventListener('click', alvo.close.bind(alvo));
          }
        }
        var bolha = document.querySelector('#cart-icon-bubble');
        if (bolha && s['cart-icon-bubble']) {
          var nb = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
          if (nb) bolha.innerHTML = nb.innerHTML;
        }
        iniciar();
      })
      .catch(function () { window.location.reload(); });
  }

  function ligarUpsells(escopo) {
    escopo.querySelectorAll('[data-vb-upsell]').forEach(function (cartao) {
      if (cartao.dataset.vbLigado === '1') return;
      cartao.dataset.vbLigado = '1';
      // trocar de variante troca o preço e o alvo do botão
      var campo = cartao.querySelector('[data-vb-select]');
      if (campo) {
        campo.addEventListener('change', function () {
          var op = campo.options[campo.selectedIndex];
          if (!op) return;
          var add = cartao.querySelector('[data-vb-add]');
          if (add) add.setAttribute('data-vb-add', op.value);
          var fmt = (window.Shopify && Shopify.money_format) || '£{{amount}}';
          var preco = cartao.querySelector('[data-vb-upsell-preco]');
          var cheio = cartao.querySelector('[data-vb-upsell-cheio]');
          var p = parseInt(op.getAttribute('data-preco'), 10) || 0;
          if (preco) preco.textContent = dinheiro(p, fmt);
          if (cheio) {
            var c = parseInt(op.getAttribute('data-cheio'), 10) || 0;
            cheio.textContent = c > p ? dinheiro(c, fmt) : '';
          }
        });
      }
      var add = cartao.querySelector('[data-vb-add]');
      if (!add) return;
      add.addEventListener('click', function () {
        if (add.disabled) return;
        add.disabled = true;
        fetch(raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-vb-add'), 10), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
          .then(recarregarGaveta)
          .catch(function () { add.disabled = false; });
      });
    });
  }

  function dinheiro(cent, fmt) {
    var v = (cent / 100).toFixed(2), p = v.split('.');
    var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)
      .replace(/<[^>]*>/g, '');
  }

  function iniciar() {
    try {
      var g = document.querySelector('cart-drawer') || document;
      ligarContador();
      ligarUpsells(g);
    } catch (e) {
      if (window.console && console.debug) console.debug('[vb-gaveta] fora do ar:', e.message);
    }
  }

  /* O tema redesenha a gaveta inteira ao mudar o carrinho (o Dawn troca o
     innerHTML de .drawer__inner). Tudo que é nosso nasce de novo e precisa ser
     religado — o relógio é ignorado para o próprio tique não disparar o vigia. */
  function vigiar() {
    var alvo = document.querySelector('cart-drawer');
    if (!alvo || !window.MutationObserver) return;
    if (window.__vbVigia) window.__vbVigia.disconnect();
    var pendente = null;
    window.__vbVigia = new MutationObserver(function (lista) {
      var vale = lista.some(function (m) {
        var no = m.target;
        return !(no && no.closest && no.closest('[data-vb-relogio]'));
      });
      if (!vale) return;
      clearTimeout(pendente);
      pendente = setTimeout(iniciar, 120);
    });
    window.__vbVigia.observe(alvo, { childList: true, subtree: true });
  }

  function ligar() { iniciar(); vigiar(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
  /* A barra de ofertas da PDP põe os itens no carrinho por conta própria e avisa
     por evento: quem redesenha e abre a gaveta é este trecho. O guarda evita que
     os três eventos seguidos virem três buscas. */
  var ultimaBusca = 0;
  function aoAdicionar(abrir) {
    var agora = Date.now();
    if (agora - ultimaBusca < 700) return;
    ultimaBusca = agora;
    recarregarGaveta(abrir);
  }
  document.addEventListener('ewc:cart:added', function () { aoAdicionar(true); });
  document.addEventListener('cart-drawer:open', function () { aoAdicionar(true); });
  document.addEventListener('cart:refresh', function () { aoAdicionar(false); });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(iniciar, 60); });
    }
  } catch (e) { /* tema sem pubsub */ }
})();
